import styled from 'styled-components';

export const Container = styled.div`
  padding: 10px;
  font-family: 'Inter';
  h1 {
    font-size: 26px;
    font-weight: 500;
    margin-bottom: 20px;
    text-align: center;
    max-width: 800px;
    margin: 0 auto 20px auto;
  }

  h2 {
    font-weight: 500;
    margin-bottom: 20px;
  }

  h3 {
    font-weight: 500;
    margin-bottom: 10px;
  }

  p {
    text-indent: 8px;
    margin-bottom: 10px;
  }

  ul {
    padding-left: 40px;

    li {
      margin-bottom: 10px;
    }
  }
`;
